import AuthService from '../../service';
const Faq = {
  getFaq(page,search){
    return AuthService.get(`faq/faq?page=${page}&search=${search}`);
  },
  showFaq(id){
    return AuthService.get(`faq/faq/${id}`);
  },
  createFaq(data){
    return AuthService.post(`faq/faq`,data);
  },
  updateFaq(id,data){
    return AuthService.put(`faq/faq/${id}`,data);
  },
  deleteFaq(id){
    return AuthService.delete(`faq/faq/${id}`);
  },
}
export default Faq
